import { createFileRoute } from "@tanstack/react-router";
import { faqJsonLd, jsonLdScript, pageHead } from "@/components/site/seo-copy";
import { faqs } from "@/components/hirekit/data";
import FAQView from "@/components/cl/views/FAQView";

const extra = [
  {
    q: "Does CLOSDD shortlist candidates for me?",
    a: "No. You see every application and decide yourself. There are no recruiters involved.",
  },
  {
    q: "How do I contact a candidate?",
    a: "Directly from their application once you've heard their pitch. You hire them yourself.",
  },
  {
    q: "Is it free for candidates?",
    a: "Always. Creating a profile, recording a pitch and applying to roles are free.",
  },
];

export const Route = createFileRoute("/faq")({
  head: () => ({
    ...pageHead("/faq"),
    scripts: [jsonLdScript(faqJsonLd([...faqs, ...extra]))],
  }),
  component: FAQView,
});
